module.exports = "/images/curva-ultima-01.svg?66f6e7df2348b046f167f6fa31ea1124";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/curva-ultima-01.svg
// module id = 7pkA
// module chunks = 0